module.exports = __webpack_public_path__ + "img/minus.5731c244.svg";